import { render } from "./DeliveryCompanyOrderList.vue?vue&type=template&id=4a52b808&scoped=true"
import script from "./DeliveryCompanyOrderList.vue?vue&type=script&lang=js"
export * from "./DeliveryCompanyOrderList.vue?vue&type=script&lang=js"

import "./DeliveryCompanyOrderList.vue?vue&type=style&index=0&id=4a52b808&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a52b808"]])

export default __exports__